// /**
// The main entry point for the OVU Form.
// * */
import React from 'react';
import ReactDOM from 'react-dom';
import OVUForm from './components/OVUForm';
import { jsx as _jsx } from "react/jsx-runtime";

var init = function init() {
  ReactDOM.render( /*#__PURE__*/_jsx(OVUForm, {}), document.getElementById('ovu-form'));
};

init();